import type {ActionSpec, ActionStruct} from '@cohort/shared/schema/apps/app';
import z from 'zod';

export const RemoveRoleInputSchema = z.object({
  discordUserId: z.string(),
  roleId: z.string(),
});
export type RemoveRoleInput = z.infer<typeof RemoveRoleInputSchema>;

export const RemoveRoleOutputSchema = z.object({});
export type RemoveRoleOutput = z.infer<typeof RemoveRoleOutputSchema>;

export type RemoveRoleActionStruct = ActionStruct<'remove-role', RemoveRoleInput, RemoveRoleOutput>;
export const RemoveRoleActionSpec: ActionSpec<RemoveRoleActionStruct> = {
  id: 'remove-role',
  inputSchema: RemoveRoleInputSchema,
  outputSchema: RemoveRoleOutputSchema,
};
